export const STATUS = {
  APPROVED: "approved",
  PENDING: "pending_approval",
  REJECTED: "rejected",
  EXPIRED: "expired",
  NOT_ALLOWED: "NOT_ALLOWED",
} as const;
export type STATUS_KEY = keyof typeof STATUS;